export const FEEDBACK_REQUEST = 'FEEDBACK_REQUEST';
export const FEEDBACK_REQUEST_SUCCESS = 'FEEDBACK_REQUEST_SUCCESS';
export const FEEDBACK_REQUEST_FAILED = 'FEEDBACK_REQUEST_FAILED';
